import adminEmployeeCertificatedApprovalTemplate from './approval/template.html';
import AdminEmployeeCertificatedApprovalCtrl from './approval';
import adminEmployeeCertificateReportTemplate from './report/template.html';
import AdminEmployeeCertificateReportCtrl from './report';
import AdminEmployeeCertificatesNavCtrl from './nav';
import adminEmployeesEmployeeNavTemplate from './nav/template.html';

const adminEmployeesCertificatesState = {
  url: '/certificates',
  abstract: true,
  views: {
    'a@app': {
      template: adminEmployeesEmployeeNavTemplate,
      controller: AdminEmployeeCertificatesNavCtrl,
      controllerAs: 'adminEmployeesEmployeeTabsCtrl'
    }
  }
};

const adminEmployeesCertificatesApprovalState = {
  url: '/certificates',
  stateName: 'CPE Certificates Approval',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: adminEmployeeCertificatedApprovalTemplate,
      controller: AdminEmployeeCertificatedApprovalCtrl,
      controllerAs: 'certApprovalCtrl'
    }
  }
};

const adminEmployeesCertificatesReportState = {
  url: '/report',
  stateName: 'CPE Certificates Report',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: adminEmployeeCertificateReportTemplate,
      controller: AdminEmployeeCertificateReportCtrl,
      controllerAs: 'certReportsCtrl'
    }
  }
};

export {
  adminEmployeesCertificatesState,
  adminEmployeesCertificatesApprovalState,
  adminEmployeesCertificatesReportState
};



// WEBPACK FOOTER //
// ./src/app/controllers/admin/certificates/index.js